// extracted by mini-css-extract-plugin
export default {"solicitorPillButtons":"Solicitor_solicitorPillButtons__51iFe"};